import KiosksManager from './KiosksManager'
export default KiosksManager
